export default __webpack_public_path__ + "static/media/fast_icon.d0165644.png";